import { Outlet } from "react-router-dom"
import "./style.scss"
import "./style.mobile.scss"

const Articles = () => {

  return (
    <div className="articles-page">
      <Outlet />
    </div>
  );
}

export default Articles;
